import { render, staticRenderFns } from "./modalOsEditarAgenda.vue?vue&type=template&id=ee2b9eac"
import script from "./modalOsEditarAgenda.vue?vue&type=script&lang=js"
export * from "./modalOsEditarAgenda.vue?vue&type=script&lang=js"
import style0 from "./modalOsEditarAgenda.vue?vue&type=style&index=0&id=ee2b9eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports